import styled from "styled-components";

export const ThemedH2 = styled.h2`
  font-family: ${(props) => props.theme.font || "Source Sans Pro"};
  font-weight: 400;
  font-size: 24px;
  color: #ffffff;
  margin-bottom: 8px;
  line-height: 32px;
`;

export const ThemedP = styled.p`
  font-family: "Source Sans Pro";
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: #ffffff;
`;
